export enum ObjectTypeEnum {
    Order,
    Strategy,
    Position,
    StructuredProductPosition,
}